import React, { useState, useEffect } from "react";
import "./Footer.scss";
import { FaPhoneAlt, FaMapMarkerAlt, FaArrowRight } from "react-icons/fa";
import { IoIosMailUnread } from "react-icons/io";
import { Link } from "react-router-dom";
import DownloadApps from "../../Common/DownloadApps/DownloadApps";
import Images from "../../Data/images";

const Footer = () => {
  const [isAccordion, setIsAccordion] = useState(window.innerWidth < 2000);
  const [openSections, setOpenSections] = useState({});

  useEffect(() => {
    const handleResize = () => {
      setIsAccordion(window.innerWidth < 2000);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  return (
    <div className="footer">
      <div className="f-maincontent">
        {/* Company Info */}
        <div className="column">
          <div className="logo">
            <img src={Images.logo1} alt="Argus Security Logo" />
          </div>

          <p className="description">
            ARGUS SECURITY INTERNATIONAL INC. <br />
            Protecting People • Property • Assets <br />
            Professional security services across Ontario.
          </p>

          <div className="contact">
            <div className="contact-item">
              <FaPhoneAlt />
              <span>+1 (416) 477-7692</span>
            </div>

            <div className="contact-item">
              <IoIosMailUnread />
              <span>info@argussecurity.ca</span>
            </div>

            <div className="contact-item">
              <FaMapMarkerAlt />
              <span>
                2985 Drew Rd. Suite 216 <br />
                Mississauga, ON L4T 0A4, Canada
              </span>
            </div>
          </div>
        </div>

        {/* Footer Sections */}

        {["EXPLORE", "SERVICES", "NEWSLETTER"].map((section) => (
          <div key={section} className="column">
            {isAccordion ? (
              <>
                <div
                  className="accordion-title"
                  onClick={() => toggleSection(section)}
                >
                  <span>{section}</span>
                </div>

                <div
                  className={`accordion-content ${
                    openSections[section] ? "open" : ""
                  }`}
                >
                  {/* Explore */}
                  {section === "EXPLORE" && (
                    <div className="explore-links">
                      <Link to="/aboutus">
                        <FaArrowRight /> About Us
                      </Link>
                      <Link to="/service">
                        <FaArrowRight /> Our Services
                      </Link>
                      <Link to="/consulting">
                        <FaArrowRight /> Security Consulting
                      </Link>
                      <Link to="/technology">
                        <FaArrowRight /> Technology & Innovation
                      </Link>
                      <Link to="/locations">
                        <FaArrowRight /> Locations
                      </Link>
                      <Link to="/career">
                        <FaArrowRight /> Careers
                      </Link>
                      <Link to="/emergencies">
                        <FaArrowRight /> Emergency Security Coverage
                      </Link>
                      <Link to="/contact">
                        <FaArrowRight /> Contact Us
                      </Link>
                    </div>
                  )}

                  {/* Services */}
                  {section === "SERVICES" && (
                    <div className="explore-links">
                      <Link to="/service/uniformedsecurity">
                        <FaArrowRight /> Uniformed Security
                      </Link>

                      <Link to="/service/mobilepatrol">
                        <FaArrowRight /> Mobile Patrol Services
                      </Link>

                      <Link to="/service/firewatch">
                        <FaArrowRight /> Fire Watch Security
                      </Link>

                      <Link to="/service/conciergesecurity">
                        <FaArrowRight /> Concierge Security
                      </Link>

                      <Link to="/service/executiveelite">
                        <FaArrowRight /> Executive & Elite Security Services
                      </Link>

                      <Link to="/service/executiveprotection">
                        <FaArrowRight /> Executive Protection
                      </Link>

                      <Link to="/service/gatehousesecurity">
                        <FaArrowRight /> Gatehouse Security
                      </Link>

                      <Link to="/service/parkingenforcement">
                        <FaArrowRight /> Parking Enforcement
                      </Link>

                      <Link to="/service/parkingmanagement">
                        <FaArrowRight /> Parking Management Solutions
                      </Link>

                      <Link to="/service/eventsecurity">
                        <FaArrowRight /> Event Security
                      </Link>

                      <Link to="/service/camerainstallations">
                        <FaArrowRight /> Camera Installations
                      </Link>

                      <Link to="/service/lossprevention">
                        <FaArrowRight /> Loss Prevention
                      </Link>

                      <Link to="/service/securitysystems">
                        <FaArrowRight /> Security Systems
                      </Link>
                    </div>
                  )}

                  {/* Newsletter */}
                  {section === "NEWSLETTER" && (
                    <div className="newsletter">
                      <p>
                        Signup to receive security updates and company news.
                      </p>

                      <input
                        type="email"
                        placeholder="Enter your email"
                        required
                      />

                      <button>REGISTER NOW</button>
                    </div>
                  )}
                </div>
              </>
            ) : (
              <>
                <div className="heading">
                  <span>{section}</span>
                </div>

                <div className="content">
                  {section === "EXPLORE" && (
                    <div className="explore-links">
                      <Link to="/aboutus">
                        <FaArrowRight /> About Us
                      </Link>
                      <Link to="/service">
                        <FaArrowRight /> Our Services
                      </Link>
                      <Link to="/consulting">
                        <FaArrowRight /> Security Consulting
                      </Link>
                      <Link to="/technology">
                        <FaArrowRight /> Technology & Innovation
                      </Link>
                      <Link to="/locations">
                        <FaArrowRight /> Locations
                      </Link>
                      <Link to="/career">
                        <FaArrowRight /> Careers
                      </Link>
                      <Link to="/emergencies">
                        <FaArrowRight /> Emergency Security Coverage
                      </Link>
                      <Link to="/contact">
                        <FaArrowRight /> Contact Us
                      </Link>
                    </div>
                  )}

                  {section === "SERVICES" && (
                    <div className="explore-links">
                      <Link to="/service/uniformedsecurity">
                        <FaArrowRight /> Uniformed Security
                      </Link>

                      <Link to="/service/mobilepatrol">
                        <FaArrowRight /> Mobile Patrol Services
                      </Link>

                      <Link to="/service/firewatch">
                        <FaArrowRight /> Fire Watch Security
                      </Link>

                      <Link to="/service/conciergesecurity">
                        <FaArrowRight /> Concierge Security
                      </Link>

                      <Link to="/service/executiveelite">
                        <FaArrowRight /> Executive & Elite Security Services
                      </Link>

                      <Link to="/service/executiveprotection">
                        <FaArrowRight /> Executive Protection
                      </Link>

                      <Link to="/service/gatehousesecurity">
                        <FaArrowRight /> Gatehouse Security
                      </Link>

                      <Link to="/service/parkingenforcement">
                        <FaArrowRight /> Parking Enforcement
                      </Link>

                      <Link to="/service/parkingmanagement">
                        <FaArrowRight /> Parking Management Solutions
                      </Link>

                      <Link to="/service/eventsecurity">
                        <FaArrowRight /> Event Security
                      </Link>

                      <Link to="/service/camerainstallations">
                        <FaArrowRight /> Camera Installations
                      </Link>

                      <Link to="/service/lossprevention">
                        <FaArrowRight /> Loss Prevention
                      </Link>

                      <Link to="/service/securitysystems">
                        <FaArrowRight /> Security Systems
                      </Link>
                    </div>
                  )}

                  {section === "NEWSLETTER" && (
                    <div className="newsletter">
                      <p>
                        Signup to receive security updates and company news.
                      </p>
                      <input
                        type="email"
                        placeholder="Enter your email"
                        required
                      />
                      <button>REGISTER NOW</button>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        ))}
      </div>

      {/* Bottom Footer */}
      <div className="f-bottom">
        <span>© 2025 Argus Security International Inc.</span>

        <p>
          Developed by{" "}
          <a
            href="https://newwayit.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            New Way IT
          </a>
        </p>
      </div>
    </div>
  );
};

export default Footer;
